export default __webpack_public_path__ + "static/media/PPMonumentExtended-Black.5d431726.woff2";